import type en from './en';

const de: typeof en = {
  chatMeeting: {
    prompt: '{{name}} hat nach einem Treffen gefragt. Treffen?',
    yes: 'Ja, Zeiten anbieten',
    decline: 'Ablehnen',
    notInterested: 'Kein Interesse',
    error: 'Das konnte nicht gespeichert werden. Bitte versuche es erneut.',
  },
  join: {
    title: 'Du hast Zugang zu einer KI-Sekretärin',
    titleThanks: '(dank {{name}})',
    scanQr:
      'Scanne den QR-Code mit deinem Handy, um eine WhatsApp-Unterhaltung mit deiner neuen Sekretärin zu starten.',
    fromThere:
      'Danach kannst du dein Konto einrichten und deiner Sekretärin deinen Papierkram überlassen!',
    openWhatsApp: 'WhatsApp öffnen',
    inviteOnlyTitle: 'Dream ist derzeit nur auf Einladung verfügbar.',
    invalidBody:
      'Dieser Einladungslink ist ungültig — er wurde möglicherweise falsch eingegeben oder ist nicht mehr aktiv. Bitte die Person, die dich eingeladen hat, um einen neuen Link, oder trag dich auf unsere Warteliste ein und wir melden uns.',
    joinWaitlist: 'Auf die Warteliste',
    loading: 'Wird geladen',
  },
  connect: {
    statusAlreadyConnected:
      'Dieses Konto ist bereits verbunden. Du kannst unten ein weiteres Konto hinzufügen.',
    statusExpired:
      'Dieser Link ist abgelaufen. Bitte deine Sekretärin um einen neuen.',
    statusInvalidToken:
      'Dieser Link ist ungültig. Bitte deine Sekretärin um einen neuen.',
    statusAlreadyLinkedOther:
      'Dieses Konto ist bereits mit einem anderen Dream-Konto verknüpft.',
    statusError:
      'Wir konnten deine Verbindungsseite nicht laden. Bitte versuche es erneut.',
    missingToken:
      'Onboarding-Token fehlt. Bitte öffne diese Seite über WhatsApp.',
    loadAccountsError: 'Verbundene Konten können gerade nicht geladen werden.',
    disconnectError: 'Dieses Konto kann nicht getrennt werden.',
    yourAccount: 'Dein Konto',
    title: 'Verbinde dein Konto',
    body1:
      'Verbinde deine E-Mails und deinen Kalender, damit deine Sekretärin deine Aufgaben im Blick behält und auf Terminkonflikte achtet.',
    body2: 'Er wird niemals eine E-Mail von deinem Konto senden.',
    allDone: 'Fertig?',
    youCan: 'Du kannst',
    returnToWhatsApp: 'zu WhatsApp zurückkehren',
    keepConnecting: ' oder weitere Konten verbinden',
    loadingAccounts: 'Deine verbundenen Konten werden geladen…',
    connectedAccount: 'Verbundenes Konto',
    disconnectAria: '{{account}} trennen',
    thisAccount: 'dieses Konto',
    connectGoogle: 'Google-Konto verbinden',
    connectAnotherGoogle: 'Weiteres Google-Konto verbinden',
    connectOutlook: 'Outlook-Konto verbinden',
    connectAnotherOutlook: 'Weiteres Outlook-Konto verbinden',
    disclaimer:
      'Wir unterstützen Gmail-, Google-Workspace- und Outlook-Konten.',
  },
  travelOptions: {
    title: 'Reiseoptionen',
    eyebrow: 'Deine Reise',
    tabs: 'Reiseoptionen',
    flights: 'Flüge',
    hotels: 'Unterkünfte',
    trains: 'Züge',
    flight: 'Flug',
    hotel: 'Unterkunft',
    train: 'Zug',
    removeTask: 'Aufgabe entfernen',
    book: 'Buchen',
    bookWithDream: 'Mit Dream buchen',
    separateTickets: 'Separate Tickets',
    separateTicketsWarning:
      'Diese Flüge werden separat gebucht. Prüfe die Umsteigezeit und plane Verspätungen ein.',
    seeReturnTimes: 'Rückflugzeiten ansehen',
    otherReturnTimes: 'Weitere Rückflugzeiten ({{count}})',
    bookBothFlights: 'Beide Flüge buchen',
    viewStay: 'Unterkunft ansehen',
    loading: 'Reiseoptionen werden geladen…',
    close: 'Schließen',
    outbound: 'Hinflug',
    return: 'Rückflug',
    returnsErrorTitle: 'Wir konnten deine Rückflüge nicht laden',
    returnsErrorBody:
      'Versuche es erneut oder geh zurück, um andere Optionen anzusehen',
    returnsRateLimited:
      'Zu viele Anfragen auf dieser Seite. Bitte warte ein paar Minuten.',
    tryAgain: 'Erneut versuchen',
    back: 'Zurück',
    returnRefreshCountdown: 'Preise werden in {{time}} aktualisiert',
    flightUnavailable:
      'Dieser Flug ist nicht mehr verfügbar. Bitte wähle einen anderen.',
    gettingLivePricesButton: 'Aktuelle Preise werden abgerufen…',
    flightBookingPending:
      'Ich buche {{time}} nach {{place}}. Ich gebe dir Bescheid, sobald es erledigt ist.',
    flightBookingConfirmed:
      'Ich habe {{time}} nach {{place}} am {{date}} gebucht.{{reference}}',
    flightBookingUnknown:
      'Ich prüfe, ob {{time}} nach {{place}} durchgegangen ist. Ich gebe dir Bescheid.',
    flightBookingNotBooked:
      'Ich konnte {{time}} nach {{place}} nicht buchen. Ich schreibe dir, was als Nächstes zu tun ist.',
    hotelBookingPending:
      'Ich buche {{name}}. Ich gebe dir Bescheid, sobald es erledigt ist.',
    hotelBookingConfirmed: 'Ich habe {{name}} gebucht.{{reference}}',
    hotelBookingUnknown:
      'Ich prüfe, ob {{name}} durchgegangen ist. Ich gebe dir Bescheid.',
    hotelBookingNotBooked:
      'Ich konnte {{name}} nicht buchen. Ich schreibe dir, was als Nächstes zu tun ist.',
    sameTicket: 'Ein Ticket',
    confirmBooking: 'Buchung bestätigen',
    traveller: 'Reisende Person',
    sort: {
      label: 'Sortieren nach',
      recommended: 'Empfohlen',
      price: 'Preis',
      departure: 'Abflugzeit',
      arrival: 'Ankunftszeit',
      duration: 'Dauer',
      rating: 'Bewertung',
    },
  },
  suggestions: {
    loading: 'Wird geladen…',
    linkExpiredTitle: 'Link abgelaufen',
    somethingOffTitle: 'Etwas stimmt nicht',
    expiredBody:
      'Dieser Link ist abgelaufen. Frag deine Sekretärin auf WhatsApp — sie schickt dir einen neuen.',
    invalidBody:
      'Dieser Link ist ungültig. Bitte öffne den Link aus deiner WhatsApp-Unterhaltung.',
    errorBody:
      'Beim Laden dieser Seite ist etwas schiefgelaufen. Bitte versuche es gleich noch einmal.',
    fromAssistantNamed: 'Von {{name}}, deiner Sekretärin',
    fromAssistant: 'Von deiner Sekretärin',
    titleLead: 'Legen wir',
    titleAccent: 'los',
    coverCopy:
      'Sechs Dinge, die andere mir jede Woche anvertrauen — echte Beispiele von echten Nutzern. Wähl eins aus, den Rest übernehme ich.',
    swipeUp: 'Nach oben wischen',
    picked: 'Ausgewählt — ich melde mich',
    swipeNext: 'Wische für das nächste',
    thatsTheLot: 'Das war alles — wähl eins aus ✦',
  },
  tour: {
    carouselAria: 'Neu bei Dream',
    whatsNew: 'Neu',
    ofCount: '{{n}} von {{total}}',
    previous: 'Zurück',
    startExploring: 'Los geht’s',
    showMeAfter: 'Zeig mir das danach',
    addedAfterList: 'Super, ich erzähle dir davon',
    addedForWhatsApp: 'Gemerkt — ich melde mich auf WhatsApp',
    added: 'Gemerkt',
    notInterested: 'Das interessiert mich nicht',
    okThanks: 'Ok, danke',
    doneTitle: 'Bis gleich auf WhatsApp',
    doneBody:
      'Alles, was dich interessiert hat, greife ich in unserem Chat auf. Du kannst diese Seite schließen.',
    openWhatsApp: 'Zurück zu WhatsApp',
    linkExpiredTitle: 'Dieser Link ist abgelaufen',
    somethingOffTitle: 'Da stimmt etwas nicht',
    expiredBody:
      'Dieser Link ist nicht mehr aktiv. Schreib deiner Sekretärin einfach auf WhatsApp und frag nach den neuen Funktionen.',
    invalidBody:
      'Dieser Link ist ungültig. Bitte öffne den Link aus deiner WhatsApp-Unterhaltung.',
    errorBody: 'Etwas ist schiefgelaufen. Bitte versuch es gleich noch einmal.',
    scenes: {
      summary: {
        name: 'Zusammenfassung',
        headline: 'Das ist neu',
        tail: 'fürs Erste.',
        line: 'Alles Abgehakte greife ich mit dir auf WhatsApp auf.',
      },
      intro: {
        name: 'Einführung',
        headline: '{{name}} hat',
        tail: 'ein paar neue Fähigkeiten.',
        line: 'Hier sind {{count}} neue Dinge von {{name}}, die du ausprobieren kannst.',
      },
      scheduling: {
        name: 'Terminplanung',
        headline: 'Nie wieder',
        tail: 'einem Termin hinterherlaufen.',
        line: 'Sag mir, wen du treffen musst und ungefähr wann. Ich stimme eine Zeit mit der Person ab und trage sie in deinen Kalender ein.',
        topic: 'Termine vereinbaren',
      },
      assistants: {
        name: 'Von Sekretärin zu Sekretärin',
        headline: 'Termine mit Kollegen,',
        tail: 'unter Sekretärinnen geklärt.',
        line: 'Wenn sie auch Dream nutzen, klären unsere Sekretärinnen die Zeit untereinander. Geteilt wird nur die Terminplanung — sonst nichts aus deinem Kalender.',
        topic: 'den Austausch mit den Sekretärinnen anderer',
      },
      shop: {
        name: 'Wocheneinkauf',
        headline: 'Dein Ocado-Einkauf,',
        tail: 'geplant und im Warenkorb.',
        line: 'Verbinde Ocado und sag mir, wie die Woche aussieht. Ich plane die Mahlzeiten, fülle den Warenkorb und frage bei dir nach, bevor bestellt wird.',
        topic: 'deinen wöchentlichen Ocado-Einkauf',
      },
      email: {
        name: 'E-Mail auf WhatsApp',
        headline: 'Auf E-Mails antworten,',
        tail: 'ohne sie zu öffnen.',
        line: 'Ich entwerfe Antworten in deinem Ton und zeige sie dir hier. Tippe auf Senden oder öffne den Entwurf, um ihn vorher zu ändern.',
        topic: 'E-Mails aus WhatsApp beantworten',
      },
      check_in: {
        name: 'Abend-Check-in',
        headline: 'Ein kurzer Check-in',
        tail: 'um 19 Uhr.',
        line: 'Was heute erledigt wurde, was noch offen ist und wie morgen aussieht — damit über Nacht nichts durchrutscht.',
        topic: 'den Check-in um 19 Uhr',
      },
      organisations: {
        name: 'Organisationen',
        headline: 'Bring Dream',
        tail: 'in dein Unternehmen.',
        line: 'Richte Dream für dein ganzes Team ein. Füge Sekretärinnen für deine wichtigsten Leute hinzu, alles über eine Karte abgerechnet — und ich helfe ihnen beim Start.',
        topic: 'Dream für deine Organisation',
      },
    },
  },
  briefing: {
    linkExpiredTitle: 'Diese Liste ist geschlossen',
    somethingOffTitle: 'Da stimmt etwas nicht',
    expiredBody:
      'Diese Morgenliste ist von einem früheren Tag. Alles noch Offene kommt wieder – oder schreib deiner Sekretärin einfach auf WhatsApp.',
    invalidBody:
      'Dieser Link ist ungültig. Bitte öffne den Link aus deiner WhatsApp-Unterhaltung.',
    errorBody:
      'Etwas ist schiefgelaufen. Bitte versuche es gleich noch einmal.',
    brandAria: 'Dream',
    listAria: 'Dein Briefing',
    navAria: 'Briefing-Navigation',
    optionsAria: 'Aktionen dafür',
    chooseAnother: 'Eine andere Aktion wählen',
    openDraft: 'Entwurf öffnen',
    copyDraft: 'Entwurf kopieren',
    copied: 'Kopiert',
    openLinkedin: 'In LinkedIn öffnen',
    openWhatsapp: 'WhatsApp öffnen',
    draftOnMac: 'Auch in WhatsApp auf deinem Mac',
    notRelevant: 'Nicht relevant',
    notRelevantAria: 'Das ist nicht relevant',
    chosen: 'Gewählt: {{label}}',
    next: 'Weiter',
    seeList: 'Deine To-do-Liste ansehen',
    previous: 'Vorheriger Punkt',
    whyPrompt:
      'Du hast Dinge wie „{{headline}}“ schon öfter übersprungen. Ein Wort dazu hilft mir, sie nicht mehr zu bringen.',
    whyPlaceholder: 'Warum ist das nicht relevant?',
    whySkip: 'Überspringen',
    whySend: 'Senden',
    whyThanks: 'Danke – notiert.',
    todosAria: 'Deine To-dos',
    today: 'Heute',
    tomorrow: 'Morgen',
    weekAria: 'Tag wählen',
    nothingPlanned: 'Nichts geplant.',
    clearDay: 'Freier Tag.',
    clearDayName: 'Freier Tag, {{name}}.',
    nothingDueToday: 'Heute ist nichts fällig.',
    getAhead: 'Schon mal vorarbeiten',
    noDate: 'Ohne Datum',
    doToday: 'Heute erledigen',
    doTodayAria: '{{title}} heute erledigen',
    spottedInEmail: 'In deinen E-Mails entdeckt',
    spottedCount_one: '{{count}} Punkt, den du vielleicht aufnehmen möchtest',
    spottedCount_other:
      '{{count}} Punkte, die du vielleicht aufnehmen möchtest',
    sinceDay: 'seit {{day}}',
    dueToday: 'Fällig heute',
    dueTomorrow: 'Fällig morgen',
    dueOn: 'Fällig {{date}}',
    addToToday: 'Für heute',
    addToTomorrow: 'Für morgen',
    addFor: 'Für {{date}}',
    addToCalendar: 'In den Kalender',
    addedToTomorrow: 'Für morgen eingetragen.',
    addedFor: 'Für {{date}} eingetragen.',
    addedToCalendar: 'In deinen Kalender eingetragen.',
    addedToCalendarAt: 'Im Kalender: {{date}}, {{time}}.',
    notNow: 'Jetzt nicht',
    doneAria: '{{title}} als erledigt markieren',
    actionsFor: 'Aktionen für {{title}}',
    delegate: 'Abgeben',
    findTime: 'Zeit finden',
    assistantFallback: 'Dream',
    notePlaceholder: 'Irgendwelche Anweisungen?',
    noteAria: 'Notiz für {{name}} zu {{title}}',
    delegateSend: 'An {{name}} abgeben',
    pickHint:
      'Tippe auf eine Aufgabe, um sie abzugeben oder Zeit dafür zu finden',
    pickedFor: 'Für: {{title}}',
    recordVoiceNote: 'Sprachnotiz aufnehmen',
    stopRecording: 'Aufnahme beenden',
    listening: 'Ich höre…',
    transcribing: 'Wird notiert…',
    delegationQueued: 'Wartet auf {{name}}',
    delegationWorking: '{{name}} arbeitet daran',
    micUnavailable: 'Das Mikrofon ist hier nicht verfügbar.',
    lookingForTime: 'Ich schaue in deinen Tag…',
    howAbout: 'Wie wäre {{time}}?',
    howAboutContext: 'Wie wäre {{time}}, {{context}}?',
    bookIt: 'Eintragen',
    otherTimes: 'Andere Zeiten',
    partMorning: 'Vormittag',
    partAfterLunch: 'Nach dem Mittag',
    partAfternoon: 'Nachmittag',
    partEndOfDay: 'Feierabend',
    booked: '{{time}} in deinem Kalender eingetragen.',
    noCalendar:
      'Es ist kein Kalender verbunden, also gibt es nichts zum Eintragen.',
    noFreeTime: 'Heute ist keine freie Zeit mehr.',
    noFreeTimeInPart: 'In diesem Tagesabschnitt ist keine Zeit frei.',
    calendarUnavailable: 'Dein Kalender ist gerade nicht erreichbar.',
  },
  booking: {
    noKey: 'Kein Buchungsschlüssel angegeben',
    invalidData: 'Ungültige Buchungsdaten erhalten',
    loadFailed:
      'Buchungsinformationen konnten nicht geladen werden. Der Link ist möglicherweise abgelaufen oder ungültig.',
    loading: 'Deine Buchungsinformationen werden geladen...',
    errorTitle: 'Fehler beim Buchungslink',
    goHome: 'Zur Startseite',
    noDataTitle: 'Keine Buchungsdaten',
    noDataBody: 'Buchungsinformationen konnten nicht geladen werden.',
    title: 'Schließe deine Flugbuchung ab',
    redirectBody:
      'Du wirst gleich weitergeleitet, um deine Flugbuchung abzuschließen.',
    provider: 'Buchungsanbieter',
    providerFallback: 'Flugbuchungsanbieter',
    redirectingIn: 'Automatische Weiterleitung in {{seconds}} Sekunden...',
    continueTo: 'Weiter zu {{provider}}',
    bookingSiteFallback: 'Buchungsseite',
    disclaimer:
      'Du wirst zur Website des Buchungsanbieters weitergeleitet, um deinen Kauf abzuschließen. Dieser Link ist sicher und läuft nach 24 Stunden ab.',
  },
  artifact: {
    proofTeamSaw: 'Was unser Team gesehen hat',
    proofScreenshotOf: 'Screenshot {{n}} von {{total}}',
    proofEmailHeading: 'Bestätigungs-E-Mail',
    proofEmailReceived: 'Erhalten {{when}}',
    proofPrivate: 'Nur Personen mit diesem Link können diese Seite sehen.',
    loading: 'Wird geladen...',
    unableToLoad: 'Laden nicht möglich',
    noShareToken: 'Kein Freigabe-Token angegeben',
    loadFailed: 'Element konnte nicht geladen werden',
    gettingLivePrices: 'Aktuelle Preise werden abgerufen',
    linkExpired: 'Dieser Link ist abgelaufen. Bitte frag nach einem neuen.',
    linkInvalid:
      'Dieser Link ist ungültig oder das Element existiert nicht mehr.',
    genericError:
      'Etwas ist schiefgelaufen. Bitte versuche es später noch einmal.',
    sessionExpired:
      'Diese Sitzung ist abgelaufen, weil du nicht angemeldet warst. Bitte Dream, den Link erneut zu senden.',
    linkExpiredShort: 'Dieser Link ist abgelaufen.',
    alreadyResponded: 'Hierauf wurde bereits geantwortet.',
    submitFailed:
      'Antwort konnte nicht übermittelt werden. Bitte versuche es erneut.',
    responseSubmitted: 'Antwort übermittelt',
    responseSubmittedBody:
      'Deine Antwort wurde gespeichert. Du kannst diese Seite schließen.',
    bookingNow: 'Wird gebucht',
    bookingNowBody:
      'Einen Moment — das wird gerade für dich gebucht. Die Bestätigung bekommst du im Chat; du kannst diese Seite schließen.',
    booked: 'Gebucht',
    bookedBody:
      'Fertig. Die Bestätigung findest du in deinem Chat. Du kannst diese Seite schließen.',
    bookedReference: 'Referenz {{reference}}',
    notBooked: 'Nicht gebucht',
    notBookedBody:
      'Es wurde nichts abgebucht. Dream wurde informiert und klärt das mit dir im Chat.',
    bookingUnknown: 'Buchung wird geprüft',
    bookingUnknownBody:
      'Die Buchung konnte nicht sofort bestätigt werden. Dream klärt das mit dem Anbieter und meldet sich im Chat — du musst nichts weiter tun.',
    paymentReceived: 'Zahlung erhalten',
    paymentReceivedBody:
      'Wir bestätigen deine Zahlung — deine Credits werden gleich gutgeschrieben. Du kannst diese Seite schließen.',
    topUpComplete: 'Aufladung abgeschlossen',
    topUpCreditsAdded:
      '{{credits}} Credits wurden deinem Konto gutgeschrieben. Du kannst diese Seite schließen.',
    topUpAlreadyDone:
      'Diese Aufladung wurde bereits abgeschlossen. Du kannst diese Seite schließen.',
    topUpMissingDetails:
      'Diesem Aufladelink fehlen die Details. Bitte frag nach einem neuen.',
    checkoutFailed:
      'Bezahlvorgang konnte nicht gestartet werden. Bitte versuche es erneut.',
    linkExpiredAskDream:
      'Dieser Link ist abgelaufen. Bitte Dream, einen neuen zu senden.',
    topUpAlreadyCompleted: 'Diese Aufladung wurde bereits abgeschlossen.',
    topUpFailed: 'Aufladung fehlgeschlagen. Deine Karte wurde nicht belastet.',
    continueSecureCheckout: 'Weiter zum sicheren Bezahlvorgang',
    cardSetupFailed:
      'Karteneinrichtung konnte nicht gestartet werden. Bitte versuche es erneut.',
    cardAdded: 'Karte hinzugefügt',
    cardAddedBody:
      'Deine Karte ist gespeichert. Deine Sekretärin kann sie jetzt aufladen, wenn du einen Kauf genehmigst. Du kannst diese Seite schließen.',
    subscriptionActive: 'Abo aktiv',
    subscriptionActiveBody:
      'Dein Tarif ist eingerichtet und deine Credits wurden gutgeschrieben. Du kannst diese Seite schließen.',
    subscriptionPendingBody:
      'Wir bestätigen dein Abo — deine Credits werden gleich gutgeschrieben. Du kannst diese Seite schließen.',
    selectPlan: 'Wähle einen Tarif',
    popular: 'BELIEBT',
    yourPlan: 'Dein Tarif',
    loadingShort: 'Wird geladen...',
    choosePlan: '{{name}} wählen',
    addCardOnly: 'Oder einfach nur eine Karte ohne Tarif hinzufügen',
    noContent: 'Kein Inhalt verfügbar.',
    alreadyHandled: 'Bereits erledigt',
    alreadyHandledTitled:
      '„{{title}}“ wurde bereits beantwortet, hier ist nichts weiter zu tun. Du kannst diese Seite schließen.',
    alreadyHandledUntitled:
      'Diese Anfrage wurde bereits beantwortet, hier ist nichts weiter zu tun. Du kannst diese Seite schließen.',
    secureLoginCancelled: 'Anmeldung abgebrochen',
    secureLoginCancelledLead: 'Anmeldung',
    secureLoginCancelledAccent: 'abgebrochen',
    secureLoginDone: 'Sicher',
    secureLoginDoneAccent: 'angemeldet',
    secureLoginDoneBody:
      'Dream kann mit deiner Anmeldung fortfahren. Du kannst diese Seite schließen.',
    secureCardSaved: 'Karte sicher',
    secureCardSavedAccent: 'gespeichert',
    secureCardSavedBody:
      'Deine Karte ist sicher gespeichert und wird nie mit deiner Sekretärin geteilt. Du kannst diese Seite schließen.',
    secureLoginCancelledBody:
      'Es wurden keine Daten gespeichert. Du kannst diese Seite schließen und deine Sekretärin jederzeit erneut fragen.',
  },
  wizard: {
    stepLabelPrivacy: 'Deine Privatsphäre',
    mobileStepPrivacy: 'Privatsphäre',
    getStarted: 'Los geht’s',
    close: 'Schließen',
    privacyStep: {
      title: 'Gib die langweiligen Aufgaben ab – nicht deine Daten',
      lede: 'Eine erstklassige Sekretärin, die deinen Alltag erledigt und deine Daten schützt.',
      point1: 'Wir trainieren unsere Modelle nicht mit deinen Daten',
      point2: 'Wir verkaufen deine Daten nie an andere',
      point3:
        'Wenn du eine App verbindest, kannst du jederzeit sehen, wie deine Sekretärin sie nutzt',
      point4:
        'Gelöscht heißt gelöscht. Deine Apps, dein Konto – wenn etwas weg sein soll, ist es weg',
      point5: 'Dream speichert keine E-Mail, die du bekommst',
      learnMore: 'Ich möchte mehr wissen',
      analyticsTitle: 'Hilf mit, deine Sekretärin besser zu machen',
      analyticsBody:
        'Hilf uns zu prüfen, wie gut deine Sekretärin arbeitet. Die Ergebnisse sind anonym, niemand liest deine Gespräche.',
      modalTitle: 'Deine Privatsphäre, einfach erklärt',
      rights: {
        memoryTitle: 'Das Recht, das Gedächtnis deiner Sekretärin zu verwalten',
        memoryBody:
          'Du kannst sehen, welche wichtigen Dinge sich deine Sekretärin über dich merkt. Du kannst sie korrigieren oder löschen lassen.',
        conversationTitle: 'Das Recht auf ein privates Gespräch',
        conversationBody:
          'Was du deiner Sekretärin sagst, bleibt privat. Wir geben Gespräche nur weiter, wenn uns das Gesetz dazu zwingt. Die Technikerinnen und Techniker von Dream dürfen ein Gespräch nur ansehen, wenn du einen Fehler gemeldet hast. Wir sagen dir dann Bescheid.',
        dataUseTitle: 'Das Recht zu wissen, wie wir deine Daten nutzen',
        dataUseBody: 'Wir verkaufen deine persönlichen Daten nicht.',
        knowTitle: 'Das Recht zu wissen, was Dream über dich weiß',
        knowBody:
          'Du kannst uns fragen, welche Daten wir über dich haben. Du bekommst dann eine Kopie.',
        correctTitle: 'Das Recht, Fehler korrigieren zu lassen',
        correctBody:
          'Wenn etwas, das wir über dich gespeichert haben, falsch ist, kannst du uns bitten, es zu korrigieren.',
        deleteTitle: 'Das Recht, deine Daten zu löschen',
        deleteBody:
          'Du kannst uns bitten, deine Daten zu löschen. Manche Daten müssen wir behalten, wenn das Gesetz es verlangt.',
        portabilityTitle: 'Das Recht, deine Daten mitzunehmen',
        portabilityBody:
          'Du kannst eine Kopie deiner Daten in einem Format bekommen, das du woanders nutzen kannst.',
        limitTitle: 'Das Recht, die Nutzung deiner Daten zu begrenzen',
        limitBody:
          'Du kannst uns bitten, deine Daten nicht mehr oder nur eingeschränkt zu nutzen – soweit die App dann noch funktioniert.',
        accessTitle: 'Das Recht zu wissen, worauf deine Sekretärin Zugriff hat',
        accessBody:
          'Du kannst sehen, auf welche Konten und Dienste deine Sekretärin zugreifen kann. Du kannst diesen Zugriff jederzeit entfernen.',
        providersTitle: 'Das Recht zu wissen, wer sonst deine Daten braucht',
        providersBody:
          'Dream arbeitet mit einigen Technik-Anbietern. Sie werden geprüft, ob sie die DSGVO einhalten.',
        securityTitle: 'Das Recht auf angemessene Sicherheit',
        securityBody:
          'Wir schützen deine Daten und verhindern, dass Unbefugte darauf zugreifen.',
      },
    },
    stepLabel1: 'Konten verbinden',
    stepLabel2: 'Tägliches Briefing',
    stepLabel3: 'Integrationen',
    stepLabel4: 'Deine Sekretärin',
    stepLabel5: 'Erste Aufgaben',
    mobileStep1: 'Konten',
    mobileStep2: 'Briefing',
    mobileStep3: 'Integrationen',
    mobileStep4: 'Sekretärin',
    mobileStep5: 'Erste Aufgaben',
    briefingSub1: 'Was es ist',
    briefingSub2: 'Wann es kommt',
    briefingSub3: 'Weitere Routinen',
    assistantSub1: 'Name',
    assistantSub2: 'E-Mail',
    assistantSub3: 'Karte',
    assistantSub4: 'Das Team',
    taskSub1: 'Schon erledigt',
    taskSub2: 'Empfehlungen',
    taskSub3: 'Deine erste Aufgabe',
    continue: 'Weiter',
    letsGetStarted: 'Los geht’s',
    back: 'Zurück',
    stepOf: '{{label}} · {{step}} von {{total}}',
    eyebrow: 'Schritt {{step}} von {{total}} · {{label}}',
    oneMoment: 'Einen Moment…',
    loadingSetup: 'Deine Einrichtung wird geladen…',
    linkErrorTitle: 'Hmm, dieser Link hat nicht funktioniert',
    missingToken:
      'Diesem Link fehlt sein Token. Bitte deine Sekretärin um einen neuen.',
    loadFailed: 'Beim Laden deiner Einrichtung ist etwas schiefgelaufen.',
    genericError: 'Etwas ist schiefgelaufen. Versuch es erneut.',
    allSetTitle: 'Alles bereit',
    allSetBody:
      'Geh zurück zu deinem WhatsApp-Chat mit {{name}} — dort wirst du schon erwartet.',
    openWhatsApp: 'WhatsApp öffnen',
    privacy: 'Datenschutz',
    terms: 'AGB',
    openingWhatsAppToast: 'WhatsApp wird geöffnet — „{{task}}“ mit {{name}}.',
    oauthMissingScopes:
      'Dein Konto ist verbunden. Der Zugriff auf {{scopes}} wurde nicht gewährt, daher kann dir deine Sekretärin bei {{area}} auf diesem Konto nicht helfen. Du kannst den Zugriff jederzeit gewähren, indem du das Konto neu verbindest.',
    oauthMissingAreaSingle: 'diesem Bereich',
    oauthMissingAreaMulti: 'diesen Bereichen',
    oauthNoMailboxTitle:
      'Verbunden – aber dieses Konto hat kein Gmail-Postfach',
    oauthNoMailbox:
      'Google meldet, dass Gmail für dieses Konto nicht aktiviert ist (der Workspace enthält kein Gmail mehr oder es ist ein Google-Login für eine Nicht-Gmail-Adresse). Deine Sekretärin kann Kalender und Kontakte nutzen, aber keine E-Mails daraus lesen, durchsuchen oder entwerfen. Wenn deine E-Mails woanders liegen, verbinde auch dieses Konto.',
    listAnd: 'und',
    oauthAlreadyLinkedOther:
      'Dieses E-Mail-Konto ist bereits mit einem anderen Konto verknüpft und konnte hier nicht hinzugefügt werden. Verbinde ein anderes oder kontaktiere uns, wenn du das für einen Fehler hältst.',
    oauthExpired:
      'Dieser Einrichtungslink ist abgelaufen. Bitte deine Sekretärin auf WhatsApp um einen neuen.',
    oauthInvalidToken:
      'Dieser Einrichtungslink ist nicht mehr gültig. Bitte deine Sekretärin auf WhatsApp um einen neuen.',
    oauthError:
      'Beim Verbinden dieses Kontos ist etwas schiefgelaufen. Bitte versuch es erneut.',
    halfModalTitle: 'Dream sieht nur die Hälfte deiner Woche',
    halfModalWork:
      'Ohne deinen Arbeitskalender werden Zeiten vorgeschlagen, zu denen du gar nicht frei bist, und das Wichtigste wird übersehen.',
    halfModalPersonal:
      'Ohne deinen privaten Kalender werden deine Abende und Wochenenden verplant, als wären sie frei.',
    connectWork: 'Arbeit verbinden',
    connectPersonal: 'Privat verbinden',
    carryOnAnyway: 'Trotzdem fortfahren',
    noAccount: {
      title: 'Ohne Konto fortfahren?',
      needs:
        '{{name}} muss deinen Kalender und deine E-Mails sehen, um dir bestmöglich helfen zu können.',
      impact:
        'Deine Verfügbarkeit kann dann nicht geprüft werden – das kann zu Terminkonflikten führen.',
      changeLater:
        'Wenn du sicher bist, wähle unten „Fortfahren“. Du kannst es später jederzeit ändern.',
      understandContinue: 'Verstanden, fortfahren',
      goBackConnect: 'Zurück und verbinden',
    },
    previewCap: 'Was ankommt um',
    previewMorning:
      'Guten Morgen{{name}} — hier ist dein Tag. Drei Meetings, zwei Antworten noch offen.',
    previewFullBriefing: 'Vollständiges Briefing zu jedem Meeting',
    previewEveningRoundUp: 'Abendlicher Überblick über offene Punkte',
    previewOwedReplies:
      'Antworten, die du schuldest — und die man dir schuldet',
    connect: {
      title: 'Verbinde deine Konten',
      ledeWide:
        'Verbinde deine E-Mail und deinen Kalender, damit {{name}} deine Aufgaben im Blick behält und auf Terminkonflikte achtet.',
      ledeNarrow:
        'Verbinde deine E-Mail und deinen Kalender, damit {{name}} deine ganze Woche sieht.',
      ledeExtra:
        'Füge dein privates und dein Arbeitskonto hinzu, damit deine ganze Woche sichtbar ist.',
      personal: 'Privat',
      personalSub: 'Dein eigenes Postfach und dein Kalender.',
      work: 'Arbeit',
      workSub: 'Wo die meisten deiner Meetings stattfinden.',
      connected: 'Verbunden',
      notConnected: 'Nicht verbunden',
      connectedAccount: 'Verbundenes Konto',
      disconnectAria: '{{account}} trennen',
      thisAccount: 'dieses Konto',
      addAnother: 'Weiteres hinzufügen',
      opening: 'Wird geöffnet…',
      openConnectError: 'Die Verbindungsseite konnte nicht geöffnet werden.',
      disconnectError: 'Konto konnte nicht getrennt werden.',
      adminNoteTitle: 'Arbeitskonto ließ sich nicht verbinden?',
      adminNoteBody:
        'Wenn du ohne Zustimmungsbildschirm direkt zurückgeschickt wurdest, muss dein Workspace-Admin Dream möglicherweise erst freigeben — hier ist ein Leitfaden, den du weiterleiten kannst.',
      adminGuideShareTitle: 'Warum Dream Zugriff auf dein Google-Konto braucht',
      sendAdminGuide: 'Leitfaden an deinen Admin senden',
      guideLinkCopied: 'Link kopiert — schick ihn deinem Admin',
      viewGuide: 'Leitfaden ansehen',
      dismiss: 'Schließen',
      connectionDidntFinish: 'Diese Verbindung wurde nicht abgeschlossen',
      neverSend: 'Es wird nie eine E-Mail von deinem Konto gesendet.',
      disclaimer:
        'Wir unterstützen Gmail-, Google-Workspace- und Outlook-Konten.',
      noAccountHint: 'Du möchtest lieber keins verbinden?',
      carryOnWithout: 'Ohne E-Mail-Konto fortfahren',
      chooseTitle: 'Verbinde ein E-Mail-Konto',
      chooseLede:
        'Gmail oder Outlook. Ich erkenne an der Adresse, ob es beruflich oder privat ist, und du kannst das ändern.',
      gmail: 'Gmail',
      outlook: 'Outlook',
      workNeededNote:
        '{{org}} braucht deine berufliche E-Mail, also verbinde diese.',
      kindAria: 'Beruflich oder privat',
      changeKindError:
        'Kontotyp konnte nicht geändert werden. Bitte erneut versuchen.',
      kindLabel: 'Was für ein Konto ist es?',
      professional: 'Beruflich',
      professionalSub: 'Deine Arbeits-E-Mail und dein Kalender.',
      neededFor: 'Erforderlich für {{org}}',
      providerLabel: 'Bei welchem Anbieter ist es?',
      google: 'Google',
      microsoft: 'Microsoft',
      other: 'Andere',
      otherNoteWork:
        '{{org}} braucht ein berufliches Google- oder Microsoft-Konto. Wenn deine Arbeits-E-Mail bei einem anderen Anbieter ist, frag dein IT-Team.',
      otherNote:
        '{{name}} funktioniert vorerst mit Google- und Microsoft-Konten. Du kannst ohne Konto weitermachen und es später verbinden.',
    },
    briefing: {
      whatTitle: 'Aufwachen — und schon im Bilde sein',
      whatLedeWide:
        'Jeden Morgen eine einzige Nachricht mit allem, was du sonst zu spät erfahren würdest.',
      whatLedeNarrow: 'Eine Nachricht jeden Morgen, per WhatsApp.',
      morningLede: 'Guten Morgen{{name}} — hier ist dein Tag.',
      line1: 'Flug nach Amsterdam, 11:05 — Bordkarte angehängt',
      line2: 'Drei Meetings, alle gebrieft mit Fotos',
      line3: 'Zwei Antworten noch offen, Entwürfe bereit',
      line4: 'Angies Geburtstag am Donnerstag',
      whatFoot: 'Kommt jeden Morgen per WhatsApp.',
      whenTitle: 'Wann soll es ankommen?',
      whenLedeWide:
        'Wähle eine Zeit, die dir passt — du kannst sie jederzeit ändern.',
      whenLedeNarrow: 'Wähle eine Zeit — du kannst sie später ändern.',
      arrivesAt: 'Kommt an um',
      onWhatsApp: 'Per WhatsApp',
      earlier15: '15 Minuten früher',
      later15: '15 Minuten später',
      deliveryTimeAria: 'Zustellzeit des Briefings',
      includeInBriefing: 'Ins Briefing aufnehmen',
      fullMeetingBriefing: 'Vollständiges Meeting-Briefing',
      alwaysOn: 'Immer aktiv',
      fullMeetingSub:
        'Fotos, wie ihr euch kennengelernt habt und wie man die Namen aller ausspricht.',
      routinesTitle: 'Was deine Sekretärin sonst noch übernehmen kann',
      routinesLede:
        'Alles ist zu Beginn aktiviert — schalte ab, was du nicht möchtest.',
      eveningTitle: 'Abendlicher Überblick über offene Punkte',
      eveningSub:
        'Eine kurze Nachricht am Ende des Tages: was liegen geblieben ist, was du erledigen wolltest und was dich am Morgen erwartet.',
      owedTitle: 'Offene Antworten im Blick',
      owedSub:
        'Dein Assistent behält im Blick, wer auf dich wartet und auf wen du wartest — und erinnert dich, bevor es peinlich wird.',
      labellingTitle: 'Posteingang sortieren und beschriften',
      labellingSub:
        'Versieht eingehende Mails mit Labels — Belege, Newsletter, Dinge, die dich brauchen — und räumt den Rest aus dem Weg. Du hältst deinen Posteingang schon selbst in Ordnung? Dann lass es aus.',
    },
    integrations: {
      title: 'Verbinde Dream mit allem anderen',
      ledeWide:
        '{{name}} kann in den Tools arbeiten, die du bereits nutzt: dort mitlesen und die Dinge erledigen, die du sonst von Hand machen würdest.',
      ledeNarrow: '{{name}} arbeitet in den Tools, die du bereits nutzt.',
      ledeExtra:
        'Verbinde jetzt, was du möchtest — oder komm später darauf zurück.',
      alreadyConnected: 'Bereits verbunden',
      whatsappRowName: 'WhatsApp',
      whatsappRowMeta: 'Wo du und {{name}} euch schreibt',
      spottedInEmail: 'In deinen E-Mails entdeckt',
      everythingElse: 'Alles andere',
      addMore: 'Mehr hinzufügen',
      showFewer: 'Weniger anzeigen',
      showAll: 'Alle {{count}} anzeigen',
      connected: 'Verbunden',
      connect: 'Verbinden',
      comingSoon: 'Bald verfügbar',
      cancel: 'Abbrechen',
      close: 'Schließen',
      verifying: 'Wird überprüft…',
      personal: 'Privat',
      work: 'Arbeit',
      connectedAccount: 'Verbundenes Konto',
      connectApp: '{{name}} verbinden',
      apiKeyBody: '{{hint}} und {{name}} überprüft ihn vor dem Speichern.',
      apiKeyDefaultHint: 'Füge deinen API-Schlüssel ein',
      apiKeyPlaceholder: '{{name}} API-Schlüssel',
      connectError: 'Verbindung nicht möglich. Versuch es erneut.',
      apps: {
        slack: {
          sub: 'Nachrichten und Kanäle',
          spottedSub:
            'Behält wichtige Kanäle im Blick, postet Updates in deinem Namen und bringt dich auf den neuesten Stand.',
        },
        hubspot: {
          sub: 'Kontakte und Deals',
          spottedSub:
            'Protokolliert Anrufe und Notizen, hält Deals und Kontakte aktuell und hakt die nächsten Schritte für dich nach.',
        },
        attio: {
          sub: 'CRM-Einträge',
          spottedSub:
            'Hält Einträge und neue Kontakte nach jedem Anruf und jeder E-Mail aktuell — ganz ohne deinen Verwaltungsaufwand.',
        },
        linear: {
          sub: 'Issues und Projekte',
          spottedSub:
            'Erstellt, aktualisiert und verfolgt Issues, damit deine Projekte weiterlaufen, während du anderswo bist.',
        },
        notion: {
          sub: 'Seiten, Listen und Datenbanken',
          spottedSub:
            'Liest deine geteilten To-do-Listen, fügt Einträge hinzu und hakt sie ab, und erstellt oder aktualisiert Seiten und Datenbanken für dich.',
        },
        asana: {
          sub: 'Aufgaben und Projekte',
          spottedSub:
            'Erstellt und aktualisiert Aufgaben aus deinen Gesprächen und hakt nach, wenn ein Projekt blockiert ist.',
        },
        todoist: {
          sub: 'Deine To-do-Liste',
          spottedSub:
            'Fügt To-dos direkt aus E-Mail und WhatsApp hinzu und hakt sie ab, sobald sie erledigt sind.',
        },
        granola: {
          sub: 'Meeting-Notizen',
          spottedSub:
            'Macht aus deinen Meeting-Notizen nach jedem Termin automatisch Aufgaben und Follow-ups.',
        },
        xero: {
          sub: 'Rechnungen und Belege',
          spottedSub:
            'Mahnt offene Rechnungen an, legt Belege ab und behält Ausgaben im Blick, ohne dass du es öffnest.',
        },
        lusha: {
          sub: 'Kontakt-Anreicherung',
          spottedSub:
            'Findet Kontaktdaten der Personen, die du erreichen möchtest — genau dann, wenn du sie brauchst.',
          keyHint: 'Füge deinen Lusha-API-Schlüssel ein',
        },
        devin: {
          sub: 'Engineering-Aufgaben',
          spottedSub:
            'Übergibt Engineering-Aufgaben, verfolgt sie bis zum Abschluss und meldet sich, wenn du gebraucht wirst.',
          keyHint: 'Füge deinen Devin-API-Schlüssel ein',
        },
      },
    },
    assistant: {
      nameTitle: 'Lerne deine Sekretärin kennen',
      nameLedeWide:
        'Er stellt sich mit diesem Namen vor. Ändere ihn, wenn du ihn lieber anders nennen möchtest.',
      nameLedeNarrow: 'Ändere ihn, wenn du ihn lieber anders nennen möchtest.',
      nameLabel: 'Name deiner Sekretärin',
      nameRequired: 'Gib deiner Sekretärin einen Namen.',
      emailTitle: '{{name}} hat eine eigene E-Mail-Adresse',
      emailLede:
        'Er kann in deinem Namen mit der Welt sprechen — und antwortet immer nur dir.',
      sigQuote:
        '…Ich habe drei Vorschläge für Donnerstag vorbereitet. Sag mir, welcher passt, und ich bestätige ihn.',
      sigRole: 'Sekretärin',
      sigRoleTo: 'Sekretärin von {{name}}',
      whenEmail: 'Wann darf er E-Mails senden?',
      expressPermission: 'Nur mit meiner ausdrücklichen Erlaubnis',
      cardTitle: 'Und eine eigene Karte',
      cardLede:
        'Zum Buchen und Kaufen in deinem Namen. Sie gibt nie ohne dein Okay Geld aus.',
      cardKind: 'Virtuell · Einmalige Nutzung',
      cardholder: 'Karteninhaber',
      expires: 'Gültig bis',
      whenSpend: 'Wann darf er Geld ausgeben?',
      teamTitle: 'Hinter {{name}} stehen Menschen',
      teamLedeWide:
        'Manche Dinge kann Software nicht erledigen. Dann übernimmt eine geschulte Person aus unserem Team — und {{name}} bleibt dein Ansprechpartner.',
      teamLedeNarrow:
        'Wenn Software es nicht kann, übernimmt ein echter Mensch. {{name}} bleibt dein Ansprechpartner.',
      whatTheyDo: 'Was sie übernehmen',
      teamItem1:
        'Ein Restaurant, eine Praxis oder einen Ort ohne Buchungssystem anrufen',
      teamItem2:
        'Sich durch eine Website arbeiten, die sich gegen Automatisierung wehrt',
      teamItem3: 'Etwas nachfassen, bei dem ein Mensch dranbleiben muss',
      playSample: 'Beispielanruf abspielen',
      pauseSample: 'Beispielanruf pausieren',
      hearCallIn: 'Anruf anhören auf',
      callLanguage: {
        en: 'Englisch',
        de: 'Deutsch',
        fr: 'Französisch',
        it: 'Italienisch',
        es: 'Spanisch',
      },
      audioTitle: 'Hör dir einen echten Anruf an: Tischreservierung',
    },
    alreadyDone: {
      putToWorkTitle: 'Lass {{name}} für dich arbeiten',
      putToWorkLede:
        'Erste Aufgabe: Antworten und Nachfassnachrichten für alles entwerfen, was in deinem Postfach wartet.',
      firstDrafts: 'Deine ersten Entwürfe',
      firstDraftsSub:
        'In wenigen Minuten fertig. {{name}} sendet nie — das machst du.',
      draftCta: 'Meine ersten Antworten entwerfen',
      hitASnag: '{{name}} ist auf ein Problem gestoßen',
      snagLede:
        'Ich konnte deine ersten Entwürfe nicht fertigstellen — aber keine Sorge, nichts ist passiert.',
      snagLine1: 'Ich entwerfe weiter, sobald neue E-Mails eintreffen',
      snagLine2: 'Nichts wird ohne dich gesendet',
      tryingAgain: 'Neuer Versuch…',
      tryAgain: 'Erneut versuchen',
      alreadyDoneTitle: 'Schon erledigt',
      emptyLede:
        'Alles auf dem neuesten Stand — gerade brauchte nichts eine Antwort.',
      emptyLine1: 'Ich entwerfe, sobald neue E-Mails eintreffen',
      emptyLine2: 'Alles wartet in deinem Entwürfe-Ordner',
      readyLede: 'Fertig — deine Entwürfe sind bereit.',
      readyLine1: 'Warten in deinem Entwürfe-Ordner',
      readyLine2: 'Bearbeite sie selbst oder bitte mich um Änderungen',
      onItTitle: '{{name}} ist dran',
      now: 'jetzt',
      working: 'In Arbeit',
      workingLede:
        'Ich gehe gerade dein Postfach durch — deine ersten Entwürfe dauern ein paar Minuten.',
      workingLine1:
        'Sie warten in deinem Entwürfe-Ordner — nichts wird ohne dich gesendet',
      workingLine2: 'Ich melde mich auf WhatsApp, sobald sie fertig sind',
      workingFoot: 'Du musst hier nicht warten — mach einfach weiter.',
    },
    referrals: {
      title: 'Lade Freunde ein, gib mehr ab',
      lede1: 'Starte mit {{amount}} an Credits pro Monat — kostenlos.',
      lede2: 'Lade einen Freund ein: Ihr bekommt beide {{amount}} an Credits.',
      lede1V3:
        'Dein erster Monat mit Dream ist kostenlos – unbegrenzte Nutzung, auf uns.',
      lede2V3:
        'Lade einen Freund ein und ihr bekommt beide Bonus-Nutzung bei Dream.',
      invitesNote:
        'Du hast diesen Monat {{count}} Einladungen — wähle jemanden, der wirklich eine Sekretärin braucht.',
      yourInviteLink: 'Dein Einladungslink',
      copied: 'Kopiert',
      copyLink: 'Link kopieren',
      copyError:
        'Dein Link konnte nicht kopiert werden — markiere ihn und kopiere ihn.',
    },
    tasks: {
      loaderTitle: 'Ich lerne dich kennen',
      loaderLede:
        'Gib mir einen Moment mit deinem Postfach und Kalender. Das habe ich bisher herausgefunden.',
      spline1: 'Den Rhythmus deiner Woche lesen',
      spline2: 'Deine Reisemuster verstehen',
      spline3: 'Herausfinden, wann du Meetings bevorzugst',
      spline4: 'Die Menschen erkennen, mit denen du am meisten sprichst',
      spline5: 'Lernen, welche E-Mails dir wirklich wichtig sind',
      spline6: 'Deine Stammlokale und wiederkehrenden Buchungen entdecken',
      spline7: 'Deine Morgen und langen Abende kennenlernen',
      spline8: 'Abos und Verlängerungen aufspüren',
      title: 'Was soll {{name}} zuerst tun?',
      lede: 'Wähle eine aus — den Rest klärst du im Chat.',
      pickOne: 'Wähle eine zum Starten',
      chooseAria: 'Erste Aufgabe wählen',
      somethingElse: 'Etwas anderes',
      somethingElseTagline: 'Du kannst nach allem fragen',
      bookRestaurant: 'Ein Restaurant reservieren',
      bookHaircut: 'Einen Friseurtermin buchen',
      findFlights: 'Flüge finden',
      yourFirstTask: 'deine erste Aufgabe',
      validation: 'Wähle eine aus, um loszulegen.',
      handoff: 'Öffnet deinen WhatsApp-Chat mit {{name}}.',
    },
  },
  // Öffentliche Gastansicht einer geteilten To-do-Liste (siehe en.ts).
  login: {
    title: 'Bei Dream anmelden',
    lede: 'Gib die Telefonnummer ein, die du mit Dream verwendest – wir schicken dir einen Einmalcode per SMS.',
    phoneLabel: 'Telefonnummer',
    countryLabel: 'Ländervorwahl',
    countrySearchPlaceholder: 'Länder suchen',
    countryNoResults: 'Keine passenden Länder',
    sendCode: 'Code senden',
    or: 'oder',
    continueWithGoogle: 'Mit Google fortfahren',
    continueWithMicrosoft: 'Mit Microsoft fortfahren',
    newHere:
      'Neu bei Dream? Starte zuerst eine Unterhaltung mit deiner Sekretärin auf WhatsApp.',
    errors: {
      empty: 'Gib deine Telefonnummer ein.',
      malformed:
        'Das sieht nicht wie eine Telefonnummer aus. Bitte nur Ziffern verwenden.',
      tooShort:
        'Diese Nummer ist zu kurz für {{selectedCountry}} ({{selectedCode}}).',
      tooLong:
        'Diese Nummer ist zu lang für {{selectedCountry}} ({{selectedCode}}).',
      countryMismatch:
        'Diese Nummer beginnt mit {{typedCode}} ({{typedCountry}}), ausgewählt ist aber {{selectedCountry}} ({{selectedCode}}). Wähle {{typedCountry}} im Dropdown oder entferne die Vorwahl.',
      invalidForCountry:
        'Das ist keine gültige Nummer für {{selectedCountry}}. Bitte prüfen und erneut versuchen.',
    },
  },
  todoGuest: {
    pageTitle: 'Geteilte To-do-Liste · Dream',
    banner:
      '<strong>{{inviter}}</strong> hat dich eingeladen, die Liste <strong>{{list}}</strong> mit Dream zu bearbeiten',
    members_one: '{{count}} Mitglied',
    members_other: '{{count}} Mitglieder',
    you: '{{name}} (du)',
    empty: 'Auf dieser Liste steht noch nichts.',
    completedByYou: 'Von dir erledigt',
    task: {
      from: 'von {{name}}',
      fromGuest: 'von {{name}} (Gast)',
      editedBy: 'bearbeitet von {{name}}',
      assignedToYou: 'Du',
      unassigned: 'Nicht zugewiesen',
      complete: 'Als erledigt markieren',
      reopen: 'Als nicht erledigt markieren',
      notYours:
        'Nur die Person, der diese Aufgabe zugewiesen ist, kann sie abhaken',
    },
    newTask: {
      button: 'Neu',
      title: 'Neue Aufgabe',
      descriptionLabel: 'Aufgabe',
      descriptionPlaceholder: 'Beschreibe deine Aufgabe',
      dueDateLabel: 'Fälligkeitsdatum hinzufügen',
      assignLabel: 'Zuweisen',
      unassigned: 'Nicht zugewiesen',
      priorityLabel: 'Priorität hinzufügen',
      noPriority: 'Keine Priorität',
      priority: {
        high: 'Hohe Priorität',
        medium: 'Mittlere Priorität',
        low: 'Niedrige Priorität',
      },
      submit: 'Aufgabe hinzufügen',
      submitting: 'Wird hinzugefügt…',
      error:
        'Die Aufgabe konnte nicht hinzugefügt werden. Bitte versuche es erneut.',
    },
    errors: {
      updateFailed:
        'Die Aufgabe konnte nicht aktualisiert werden. Bitte versuche es erneut.',
    },
    verify: {
      titleWhatsApp: 'Dein Code ist auf WhatsApp',
      titleEmail: 'Dein Code ist in deiner E-Mail',
      bodyWhatsApp:
        'Um die Liste <strong>{{list}}</strong> von <strong>{{inviter}}</strong> zu öffnen, gib den 6-stelligen Code ein, den wir gerade per WhatsApp an <strong>{{destination}}</strong> gesendet haben.',
      bodyEmail:
        'Um die Liste <strong>{{list}}</strong> von <strong>{{inviter}}</strong> zu öffnen, gib den 6-stelligen Code ein, den wir gerade an <strong>{{destination}}</strong> gesendet haben.',
      codeLabel: 'Bestätigungscode',
      submit: 'Liste öffnen',
      checking: 'Wird geprüft…',
      sending: 'Dein Code wird gesendet…',
      resendIn_one: 'Code erneut senden in {{count}} Sekunde',
      resendIn_other: 'Code erneut senden in {{count}} Sekunden',
      resend: 'Code erneut senden',
      sendCode: 'Code an mich senden',
      errors: {
        invalid: 'Dieser Code stimmt nicht. Versuche es erneut.',
        invalidWithAttempts_one:
          'Dieser Code stimmt nicht. Noch {{count}} Versuch.',
        invalidWithAttempts_other:
          'Dieser Code stimmt nicht. Noch {{count}} Versuche.',
        expired: 'Dieser Code ist abgelaufen. Fordere einen neuen an.',
        tooManyAttempts:
          'Zu viele falsche Versuche. Fordere einen neuen Code an.',
        sendFailed:
          'Dein Code konnte gerade nicht gesendet werden. Bitte versuche es erneut.',
        generic: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
      },
    },
    invalid: {
      title: 'Dieser Link ist abgelaufen. Du musst erneut eingeladen werden.',
      body: 'Hol dir deine eigene Sekretärin für Listen und vieles mehr.',
      cta: 'Jetzt über WhatsApp registrieren',
    },
    nudge: {
      title: 'Erreiche noch mehr mit deiner eigenen KI-Sekretärin',
      body: 'Hol dir eine erstklassige Sekretärin, unterstützt von echten, geschulten Sekretärinnen, die deinen Alltag für dich regelt.',
      getYourOwnPa: 'Eigene Sekretärin holen',
      phonePrompt:
        'Starte den Chat mit deiner Sekretärin auf WhatsApp — gib deine Telefonnummer ein',
      phonePlaceholder: 'Deine Telefonnummer',
      phoneSubmit: 'Auf WhatsApp fortfahren',
      phoneInvalid:
        'Bitte gib eine gültige Telefonnummer mit Ländervorwahl ein.',
      outcome: {
        sent: 'Erledigt — schau in WhatsApp nach, deine neue Sekretärin hat dir gerade geschrieben.',
        already_on_dream:
          'Diese Nummer hat bereits ein Dream-Konto. Öffne WhatsApp, um weiter mit deiner Sekretärin zu chatten.',
        already_invited:
          'Du hast die Anmeldung bereits begonnen — öffne WhatsApp, um dort weiterzumachen.',
      },
      error: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
      later: 'Vielleicht später',
    },
  },
  expenseReview: {
    headingSingle: 'Dein Erstattungsantrag',
    headingMulti: 'Deine Erstattungsanträge',
    subSingle:
      'Noch nicht gesendet. Wähle „Senden“ oder sag deiner Sekretärin Bescheid, wenn du bereit bist.',
    subMulti:
      'Noch nicht gesendet. Wähle „Senden“ oder sag deiner Sekretärin Bescheid, wenn du bereit bist.',
    alreadySubmittedSingle: 'Diese Ausgabe wurde bereits gesendet.',
    alreadySubmittedMulti: 'Diese Ausgaben wurden bereits gesendet.',
    empty: 'Diese Prüfung enthält keine Ausgaben.',
    submit: 'Senden',
    submitting: 'Wird gesendet…',
    submitAll: 'Alle {{count}} senden',
    submitSome: '{{selected}} von {{total}} senden',
    close: 'Schließen',
    notNow: 'Nicht jetzt',
    error: 'Dream ist nicht erreichbar. Bitte versuche es erneut.',
    include: '{{vendor}} einbeziehen',
    thisExpense: 'diese Ausgabe',
    unknownVendor: 'Unbekannter Anbieter',
    amountMissing: 'Betrag fehlt',
    duplicate:
      'Sieht aus wie ein Duplikat einer bereits erfassten Ausgabe (Ref. {{ref}}).',
    rows: {
      settledOnCard: '{{amount}} auf der Karte',
      inYourAccounts: 'In deiner Buchhaltung öffnen',
    },
    paymentMethod: {
      company_card: 'Firmenkarte',
      personal_card: 'Private Karte (Erstattung)',
    },
    status: {
      draft: 'Entwurf',
      awaiting_info: 'Angaben fehlen',
      awaiting_confirmation: 'Bereit zum Buchen',
      approved: 'Freigegeben',
      submitted: 'Gebucht',
      failed: 'Buchung fehlgeschlagen',
      discarded: 'Verworfen',
    },
    receipts: {
      none: 'Kein Beleg angehängt',
      fallbackName: 'Beleg {{n}}',
      openInDream: 'Öffne Dream, um die Datei zu sehen',
    },
  },
};

export default de;
